module.exports = __webpack_public_path__ + "static/media/fig_13e2.96a3170d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_13e2.jpg
// module id = 641
// module chunks = 0